import { useState } from 'react';
import mapValues from 'lodash/mapValues';
import { PROFILE_FIELDS_TYPES } from '../../../constants/formFields';

const initialFormState = {
  [PROFILE_FIELDS_TYPES.FIRST_NAME]: '',
  [PROFILE_FIELDS_TYPES.LAST_NAME]: '',
  [PROFILE_FIELDS_TYPES.RELATION]: '',
  [PROFILE_FIELDS_TYPES.CARE_ROLE]: '',
  [PROFILE_FIELDS_TYPES.EMAIL]: '',
  [PROFILE_FIELDS_TYPES.PHONE_NUMBER]: '',
};

export function useEmergencyFormState(initialState = initialFormState) {
  const [emergencyState, setEmergencyContact] = useState(initialState);

  function handleEmergencyFormChange(value) {
    setEmergencyContact({ ...emergencyState, ...value });
  }

  function clearEmergencyForm() {
    setEmergencyContact(mapValues(emergencyState, () => ''));
  }

  return { emergencyState, handleEmergencyFormChange, clearEmergencyForm };
}

const requiredFields = [
  PROFILE_FIELDS_TYPES.FIRST_NAME,
  PROFILE_FIELDS_TYPES.LAST_NAME,
  PROFILE_FIELDS_TYPES.RELATION,
  PROFILE_FIELDS_TYPES.CARE_ROLE,
];

export function validateRequiredFields(patientData) {
  return (
    requiredFields.every(type => Boolean(patientData[type])) &&
    Boolean(
      patientData[PROFILE_FIELDS_TYPES.EMAIL] ||
        patientData[PROFILE_FIELDS_TYPES.PHONE_NUMBER],
    )
  );
}



// WEBPACK FOOTER //
// ./src/components/PatientRegistration/PatientEmergencyContact/useEmergencyFormState.jsx